import { AxiosResponse } from "axios";
import { api } from "../api";
import { StandardResponse } from "../interfaces/Common";
import { PaginatedNotification } from "../interfaces/Notification";

export async function getNotifications(params?: { page?: number; }): Promise<StandardResponse<PaginatedNotification>> {
    const response: AxiosResponse<StandardResponse<PaginatedNotification>> = await api.get("/updates", {
        params
    });
    return response.data;
}

export async function markNotificationAsRead(notificationId: string): Promise<StandardResponse<string[]>> {
    const response: AxiosResponse<StandardResponse<string[]>> = await api.post("/updates/actions", {
        notificationId,
        action: 'read'
    });
    return response.data;
}